import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=637379e7&"
import script from "./TicketsTable.vue?vue&type=script&lang=js&"
export * from "./TicketsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637379e7')) {
      api.createRecord('637379e7', component.options)
    } else {
      api.reload('637379e7', component.options)
    }
    module.hot.accept("./TicketsTable.vue?vue&type=template&id=637379e7&", function () {
      api.rerender('637379e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tables/TicketsTable.vue"
export default component.exports